export default function useGAnalytics() {
  const nuxtApp = useNuxtApp();
  const propertyId = useRuntimeConfig().public.GA_PROPERTY_ID as string;

  const enabled = computed(() =>
    nuxtApp.$appConfig?.integrations.includes("google_analytics_integration"),
  );

  const getGAnalyticsScript = () => {
    if (enabled.value && propertyId) {
      return [
        {
          async: true,
          src: `https://www.googletagmanager.com/gtag/js?id=${propertyId}`,
        },
        {
          innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${propertyId}');
            `,
        },
      ];
    }
    return [];
  };

  return { getGAnalyticsScript };
}
